import '~app/sentry';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { config } from '~app/config';
import { ApiProvider, PortalQueryClientProvider } from '~app/providers';
import { router } from '~app/router';

import { AuthApiProvider } from '~domains/auth';

import { initAmpli } from '~entities/ampli';
import { growthBookInstance } from '~entities/growthbook';
import { logger } from '~entities/logger';

// import '~entities/telemetry';
import { WebRequestClient } from '~shared/api/scp/client/web-request/web-request';
import { getAwsWafDomains } from '~shared/lib/aws-waf';
import { ConfirmationProvider } from '~shared/ui/confirmation';

import log from '@tinkoff/request-plugin-log';

import * as Sentry from '@breeze/web-lib-sentry';
import { Toaster } from '@breezeventures/ui-kit/toast';
import { enrichErrorPlugin } from '@breezeventures/web-lib-ph-request/plugins/enrich-error-plugin';
import { initAwsWaf } from '@breezeventures/web-ph-aws-waf-tools/init-aws-waf';
import { GrowthBookProvider } from '@growthbook/growthbook-react';

import './globals.css';
import './index.css';

if (config.environment !== 'local') {
  initAwsWaf({
    cookieDomainList: getAwsWafDomains(),
    env: config.environment === 'prod' ? 'prod' : 'test',
  });
}

initAmpli();

const root = document.getElementById('root') as HTMLElement;

// window.msw = {
//   ...(window.msw ?? {}),
//   initialHandlersOverrides: {
//     checkPartnerSelfie: {
//       scenario: 'no-selfie',
//     },
//     // getPartnerApplicationsByPerson: {
//     //   payload: [],
//     // },
//   },
// };

const enableMocking = config.isMockingEnabled || !!window.TURN_ON_MSW;

const startMocking = enableMocking
  ? async () => {
      const [{ handlers }, { setupMocking }] = await Promise.all([
        import('~app/mocks'),
        import('~shared/msw-kit'),
      ]);
      return setupMocking({ enabled: true, handlers });
    }
  : () => Promise.resolve();

startMocking()
  .then(() => {
    ReactDOM.createRoot(root).render(
      // <React.StrictMode>
      <GrowthBookProvider growthbook={growthBookInstance}>
        <ApiProvider
          config={config}
          scpClient={
            new WebRequestClient({
              plugins: [
                log({ name: 'client-api', logger }),
                enrichErrorPlugin(),
              ],
            })
          }
        >
          <ConfirmationProvider>
            <Toaster position="top-right" />
            <AuthApiProvider>
              <PortalQueryClientProvider>
                <Sentry.ErrorBoundary
                  fallback={<div>Something went wrong</div>}
                >
                  <RouterProvider router={router} />
                </Sentry.ErrorBoundary>
              </PortalQueryClientProvider>
            </AuthApiProvider>
          </ConfirmationProvider>
        </ApiProvider>
      </GrowthBookProvider>
      // </React.StrictMode>
    );
  })
  .catch(() => {
    // Error handling
  });
